<svg
  aria-hidden="true"
  class="icon"
  [ngClass]="['icon--' + size, 'icon--' + variant]"
  xmlns="http://www.w3.org/2000/svg">
  <use [attr.xlink:href]="link" [attr.href]="link"/>
</svg>
